import * as React from "react";
const Reply = (props) => (
  <svg
    width={14}
    height={12}
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.8 11H10.8C8.03858 11 5.8 8.76142 5.8 6V1M5.8 1L10.6 4.2M5.8 1L1 4.2"
      stroke="#969BA1"
      strokeWidth={1.5}
    />
  </svg>
);
export default Reply;